import { render, staticRenderFns } from "./SendPDFButton.vue?vue&type=template&id=1c72dba6&scoped=true"
import script from "./SendPDFButton.vue?vue&type=script&lang=ts"
export * from "./SendPDFButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72dba6",
  null
  
)

export default component.exports